/* Rquiere de mixin.js */

var worker = {
	data () {
		return {
            listWorkers: [
                { 'id': 1, 'name': 'Evelyn Andrea', 'lastName': 'Aguilera Reis', 'status_id': 1, 'worker_departament': [{'worker_id': 1, 'departament_id': 3 }]},
                { 'id': 2, 'name': 'Patricia Del Pilar', 'lastName': 'Araya Aguilera', 'status_id': 1, 'worker_departament': [{'worker_id': 2, 'departament_id': 8 }]},
                { 'id': 3, 'name': 'Oscar Luis', 'lastName': 'Arratia Matus', 'status_id': 1, 'worker_departament': [{'worker_id': 3, 'departament_id': 8 }]},
                { 'id': 4, 'name': 'Jesús Alejandro', 'lastName': 'Astudillo Rivas', 'status_id': 1, 'worker_departament': [{'worker_id': 4, 'departament_id': 8 }]},
                { 'id': 5, 'name': 'David Samuel', 'lastName': 'Benavente González', 'status_id': 2, 'worker_departament': [{'worker_id': 5, 'departament_id': 8 }]},
                { 'id': 6, 'name': 'Ronald David', 'lastName': 'Caballero Pintos', 'status_id': 2, 'worker_departament': [{'worker_id': 6, 'departament_id': 2 }]},
                { 'id': 7, 'name': 'Francisco Javier', 'lastName': 'Canales Vasquez', 'status_id': 1, 'worker_departament': [{'worker_id': 7, 'departament_id': 7 }]},
                { 'id': 8, 'name': 'Yuri Mauricio', 'lastName': 'Cigna Oyaneder', 'status_id': 1, 'worker_departament': [{'worker_id': 8, 'departament_id': 10 }]},
                { 'id': 9, 'name': 'Rossana Jacqueline', 'lastName': 'Folchi Arriagada', 'status_id': 1, 'worker_departament': [{'worker_id': 9, 'departament_id': 1 }]},
                { 'id': 10, 'name': 'Ellen Esther', 'lastName': 'Leiva Contreras', 'status_id': 1, 'worker_departament': [{'worker_id': 10, 'departament_id': 3 }]},
                { 'id': 11, 'name': 'Italo Isidro', 'lastName': 'Navarrete Vilchez', 'status_id': 1, 'worker_departament': [{'worker_id': 11, 'departament_id': 9 }, {'worker_id': 11, 'departament_id': 6 }]},
                { 'id': 12, 'name': 'Jonathan Ismael', 'lastName': 'Neira Gaete', 'status_id': 2, 'worker_departament': [{'worker_id': 12, 'departament_id': 6 }]},
                { 'id': 13, 'name': 'Fernando Alfonso', 'lastName': 'Orellana Rojas', 'status_id': 2, 'worker_departament': [{'worker_id': 13, 'departament_id': 6 }]},
                { 'id': 14, 'name': 'Jessica Andrea', 'lastName': 'Perez Valdivia', 'status_id': 1, 'worker_departament': [{'worker_id': 14, 'departament_id': 1 }]},
                { 'id': 15, 'name': 'Gustavo Alejandro', 'lastName': 'Pineda Ortiz', 'status_id': 1, 'worker_departament': [{'worker_id': 15, 'departament_id': 2 }]},
                { 'id': 16, 'name': 'María Esperanza', 'lastName': 'Rios Tinoco', 'status_id': 2, 'worker_departament': [{'worker_id': 16, 'departament_id': 10 }]},
                { 'id': 17, 'name': 'Jesús Daniel', 'lastName': 'Salgar Cordova', 'status_id': 1, 'worker_departament': [{'worker_id': 17, 'departament_id': 3 }]},
                { 'id': 18, 'name': 'Willian', 'lastName': 'Sangama Tenazoa', 'status_id': 2, 'worker_departament': [{'worker_id': 18, 'departament_id': 6 }]},
                { 'id': 19, 'name': 'Yanet', 'lastName': 'Sanjuan Murillo', 'status_id': 1, 'worker_departament': [{'worker_id': 19, 'departament_id': 10 }]},
                { 'id': 20, 'name': 'Maria Luisa', 'lastName': 'Suazo Pereira', 'status_id': 1, 'worker_departament': [{'worker_id': 20, 'departament_id': 10 }]},
                { 'id': 21, 'name': 'María Angela', 'lastName': 'Valdés Medina', 'status_id': 1, 'worker_departament': [{'worker_id': 21, 'departament_id': 10 }]},
                { 'id': 22, 'name': 'Javier Alejandro', 'lastName': 'Vera Galaz', 'status_id': 2, 'worker_departament': [{'worker_id': 22, 'departament_id': 8 }]},
                { 'id': 23, 'name': 'Alison Andrea', 'lastName': 'Jimenez Prieto', 'status_id': 1, 'worker_departament': [{'worker_id': 23, 'departament_id': 4 }]},
                { 'id': 24, 'name': 'Marcelo Alejandro', 'lastName': 'Gonzalez Inostroza', 'status_id': 1, 'worker_departament': [{'worker_id': 24, 'departament_id': 6 }]},
                { 'id': 25, 'name': 'Juolmary Celeste', 'lastName': 'Martínez Caruci', 'status_id': 1, 'worker_departament': [{'worker_id': 25, 'departament_id': 6 }]},
                { 'id': 26, 'name': 'José Luis', 'lastName': 'Ramirez González', 'status_id': 1, 'worker_departament': [{'worker_id': 26, 'departament_id': 6 }]},
            ],
            workersDepartamentSelected: -1,
            workersStatusView: 1
		}
	},
	computed: {
        listWorkersByworkersDepartamentSelected() {
            let listWorkersFilter = []
            if(this.workersDepartamentSelected < 0) {
                listWorkersFilter = this.listWorkers
            } else {
                listWorkersFilter = this.listWorkers.filter(
                    item => {
                        let index = item.worker_departament.map((el) => parseInt(el.departament_id)).indexOf(parseInt(this.workersDepartamentSelected))
                        index = (index > -1 && (this.workersStatusView == -1 || this.workersStatusView == item.status_id)) ? index : -1
                        return (index > -1) ? true : false
                    }
                );
            }
            return listWorkersFilter
        }
	},
	filters: {
	},
	methods:{
        getAllWorkers() {
            let url = this.getApiBackend + 'workers'
            console.log(url)
        },
        getAllWorkersResult(response) {
            if(response.data.success == true) {
                this.listWorkers = response.data.data
            }
            this.getAllWorkersResultLocal(response)
        },
        getAllWorkersResultLocal(response) {
            console.log('getAllWorkersResultLocal no desarrollado', response)
        },
        getWorkersByDepartament(departamentId) {
            let param = '?assets=' + true
            let url = this.getApiBackend + 'departament/' + departamentId + '/workers'
            console.log(url)
        }
	},
};

export default worker;